import { ClassProvider, ExistingProvider } from '@angular/core';

import { CustomersListingModelService } from '../pages/csr/customers/customers-listing-model.service';
import { EventConfigurationListingModelService } from '../pages/administration/event-configuration/event-configuration-listing-model.service';
import { ReportGroupsListingModelService } from '../pages/administration/report-groups/report-groups-listing-model.service';
import { ReportsListingModelService } from '../pages/reporting/components/reports-list/reports-listing-model.service';
import { SubscriptionManagementListingModelService } from '../pages/administration/subscription-management/subscription-management-listing-model.service';
import { UserRolesListingModelService } from '../pages/administration/user-roles/user-roles-listing-model.service';
import { LISTING_MODEL } from '../shared/constants/tokens';

export const customersModelProvider: ClassProvider = {
  provide: LISTING_MODEL,
  useClass: CustomersListingModelService
};

export const eventConfigurationModelProvider: ExistingProvider = {
  provide: LISTING_MODEL,
  useExisting: EventConfigurationListingModelService
};

export const reportGroupsModelProvider: ExistingProvider = {
  provide: LISTING_MODEL,
  useExisting: ReportGroupsListingModelService
};

export const reportsModelProvider: ExistingProvider = {
  provide: LISTING_MODEL,
  useExisting: ReportsListingModelService
};

export const subscriptionManagementModelProvider: ClassProvider = {
  provide: LISTING_MODEL,
  useClass: SubscriptionManagementListingModelService
};

export const userRolesModelProvider: ExistingProvider = {
  provide: LISTING_MODEL,
  useExisting: UserRolesListingModelService
};
